<template>
  <div class="register absolute">
    <div class="shading">
      <div class="pictrue acea-row row-center-wrapper">
        <img :src="logoUrl" v-if="logoUrl" />
        <img src="@assets/images/minilogo.png" v-else />
      </div>
      <div class="title">B2C Mall</div>
    </div>
    <div class="whiteBg" v-if="formItem === 1">
      <div class="title acea-row row-center-wrapper">
        <div
          class="item"
          :class="current === index ? 'on' : ''"
          v-for="(item, index) in navList"
          @click="navTap(index)"
          :key="index"
        >
          {{ item }}
        </div>
      </div>
      <div class="list" :hidden="current !== 0">
        <form @submit.prevent="submit">
          <div class="item">
            <div class="acea-row ">
              <svg class="icon" aria-hidden="true">
                <use xlink:href="#icon-phone_"></use>
              </svg>
              <span class="chooseArea" @click="chooseArea()">
                <slot name="country_tel">+{{ area }}</slot>
                <span
                  ><svg
                    t="1566640213388"
                    class="icon"
                    viewBox="0 0 1024 1024"
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    p-id="2787"
                    width="18"
                    height="18"
                  >
                    <path
                      d="M512 721.5c-4.6 0-9.2-1.8-12.7-5.3l-383.1-383c-7-7-7-18.4 0-25.5s18.4-7 25.5 0L512 678.1l370.3-370.3c7-7 18.4-7 25.5 0 7 7 7 18.4 0 25.5l-383.1 383c-3.5 3.5-8.1 5.2-12.7 5.2z"
                      p-id="2788"
                    ></path></svg
                ></span>
              </span>
              <input
                type="text"
                placeholder="Enter your phone number"
                v-model="account"
                required
              />
            </div>
          </div>
          <div class="item">
            <div class="acea-row row-between-wrapper">
              <svg class="icon" aria-hidden="true">
                <use xlink:href="#icon-code_"></use>
              </svg>
              <input
                type="password"
                placeholder="Fill in your password"
                v-model="password"
                required
              />
            </div>
          </div>
        </form>
        <div
          class="forgetPwd"
          @click="$router.push({ name: 'RetrievePassword' })"
        >
          <span class="iconfont icon-wenti"></span>Forgot password
        </div>
      </div>
      <div class="list" :hidden="current !== 1">
        <div class="item">
          <div class="acea-row row-between-wrapper">
            <svg class="icon" aria-hidden="true">
              <use xlink:href="#icon-phone_"></use>
            </svg>
            <span class="chooseArea" @click="chooseArea()">
              <slot name="country_tel">+{{ area }}</slot>
              <span
                ><svg
                  t="1566640213388"
                  class="icon"
                  viewBox="0 0 1024 1024"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  p-id="2787"
                  width="18"
                  height="18"
                >
                  <path
                    d="M512 721.5c-4.6 0-9.2-1.8-12.7-5.3l-383.1-383c-7-7-7-18.4 0-25.5s18.4-7 25.5 0L512 678.1l370.3-370.3c7-7 18.4-7 25.5 0 7 7 7 18.4 0 25.5l-383.1 383c-3.5 3.5-8.1 5.2-12.7 5.2z"
                    p-id="2788"
                  ></path></svg
              ></span>
            </span>
            <input type="text" placeholder="Enter your phone number" v-model="account" />
          </div>
        </div>
        <div class="item">
          <div class="align-left">
            <svg class="icon" aria-hidden="true">
              <use xlink:href="#icon-code_1"></use>
            </svg>
            <input
              type="text"
              placeholder="Please fill in verification code"
              class="codeIput"
              v-model="captcha"
            />
            <button
              class="code"
              :disabled="disabled"
              :class="disabled === true ? 'on' : ''"
              @click="code"
            >
              {{ text }}
            </button>
          </div>
        </div>
      </div>
      <div class="logon" @click="loginMobile" :hidden="current !== 1">Login</div>
      <div class="logon" @click="submit" :hidden="current === 1">Login</div>
      <div class="tip">
        There is no account?
        <span @click="ToRegister" class="font-color-blue">Register</span>
        <!--Facebook登录按钮-->
        <!--<fb-signin-button-->
          <!--:params="fbSignInParams"-->
          <!--@success="onSignInSuccess"-->
          <!--@error="onSignInError"-->
        <!--&gt;-->
          <!--Sign in with Facebook-->
        <!--</fb-signin-button>-->
      </div>
    </div>
    <div class="whiteBg" v-else>
      <div class="title">Register</div>
      <div class="list">
        <div class="item">
          <div>
            <svg class="icon" aria-hidden="true">
              <use xlink:href="#icon-phone_"></use>
            </svg>
            <!-- 选择地区 -->
            <span class="chooseArea" @click="chooseArea()">
              <slot name="country_tel">{{area}}</slot>
              <span
                ><svg
                  t="1566640213388"
                  class="icon"
                  viewBox="0 0 1024 1024"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  p-id="2787"
                  width="18"
                  height="18"
                >
                  <path
                    d="M512 721.5c-4.6 0-9.2-1.8-12.7-5.3l-383.1-383c-7-7-7-18.4 0-25.5s18.4-7 25.5 0L512 678.1l370.3-370.3c7-7 18.4-7 25.5 0 7 7 7 18.4 0 25.5l-383.1 383c-3.5 3.5-8.1 5.2-12.7 5.2z"
                    p-id="2788"
                  ></path></svg
              ></span>
            </span>
            <input type="text" placeholder="Enter your phone number" v-model="account" />
          </div>
        </div>
        <div class="item">
          <div class="align-left">
            <svg class="icon" aria-hidden="true">
              <use xlink:href="#icon-code_1"></use>
            </svg>
            <input
              type="text"
              placeholder="Please fill in verification code"
              class="codeIput"
              v-model="captcha"
            />
            <button
              class="code"
              :disabled="disabled"
              :class="disabled === true ? 'on' : ''"
              @click="code"
            >
              {{ text }}
            </button>
          </div>
        </div>
        <div class="item">
          <div>
            <svg class="icon" aria-hidden="true">
              <use xlink:href="#icon-code_"></use>
            </svg>
            <input
              type="password"
              placeholder="Fill in your password"
              v-model="password"
            />
          </div>
        </div>
      </div>
      <div class="logon" @click="register">Register</div>
      <div class="tip">
        Have an existing account?
        <span @click="formItem = 1" class="font-color-red">Login</span>
      </div>
    </div>
    <!-- <div class="bottom"></div> -->
  </div>
</template>
<script>
import sendVerifyCode from "@mixins/SendVerifyCode";
import {
  login,
  loginMobile,
  registerVerify,
  register,
  fb_login
} from "@api/user";
import {getHomeData} from  "@api/public";
import attrs, { required, alpha_num, chs_phone } from "@utils/validate";
import { validatorDefaultCatch } from "@utils/dialog";
import { getLogo } from "@api/public";
import dayjs from "dayjs";
import cookie from "@utils/store/cookie";

const BACK_URL = "login_back_url";

export default {
  name: "Login",
  mixins: [sendVerifyCode],

  data: function() {
    return {
      // navList: ["Account login", "Fast login"],
      navList: ["Account login"],
      fbSignInParams: {
        scope: "public_profile,email",
        return_scopes: true
      },
      message: "",
      current: 0,
      account: "",
      password: "",
      captcha: "",
      area: "63",
      formItem: 1,
      type: "login",
      logoUrl: ""
    };
  },
  mounted: function() {


    getHomeData().then(res => {
      this.localStorage.set("default_country_code",res.data.default_country_code)
      this.area = this.localStorage.get("Area")
              ? this.localStorage.get("Area")
              : this.localStorage.get("default_country_code");
    });


    this.getLogoImage();
    this.initFaceBookSDK();
  },
  watch: {
    $route() {
      // this.area = this.$route.params.tel?this.$route.params.tel:this.localStorage.get("default_country_code");
      this.area = this.localStorage.get("Area")
        ? this.localStorage.get("Area")
        : this.localStorage.get("default_country_code");
      this.initFaceBookSDK();
    }
  },
  methods: {
    initFaceBookSDK() {
      // console.log('初始化FB SDK')
      // 初始化FB SDK
      // window.fbAsyncInit = function() {
      //   FB.init({
      //     appId: '514042196164251',
      //     xfbml: true,
      //     status: true,
      //     cookie: true,
      //     autoLogAppEvents: true,
      //     version: 'v6.0'
      //   })
      // }
    },
    onSignInSuccess(response) {
      this.$dialog.loading.open("loading");

      FB.api("/me", dude => {
        // console.log('dude',dude) //返回第三方的登录信息 tolen等
        fb_login({ name: dude.name, id: dude.id,spread: cookie.get("spread")})
          .then(({ data }) => {
            this.$dialog.loading.close();
            // console.log('fb_login',data)
            this.$store.commit("LOGIN", data.token, dayjs(data.expires_time));
            const backUrl = cookie.get(BACK_URL) || "/";
            cookie.remove(BACK_URL);
            this.$router.replace({ path: backUrl });
          })
          .catch(e => {
            this.$dialog.loading.close();
            this.$dialog.error(e.msg);
          });
      });
      // console.log(response) //返回第三方的登录信息 tolen等
    },
    onSignInError(error) {
      this.$dialog.loading.close();
    },

    chooseArea: function() {
      this.$router.push({ path: "/selectCode" });
    },
    ToRegister() {
      this.$router.push({ path: "/Register" });
    },
    async getLogoImage() {
      let that = this;
      getLogo(2).then(res => {
        that.logoUrl = res.data.logo_url;
      });
    },
    async loginMobile() {
      var that = this;
      const { account, captcha } = that;
      try {
        await that
          .$validator({
            captcha: [
              required(required.message("verification code")),
              alpha_num(alpha_num.message("verification code"))
            ]
          })
          .validate({ account, captcha });
      } catch (e) {
        return validatorDefaultCatch(e);
      }
      loginMobile({
        phone: that.area + that.account,
        captcha: that.captcha,
        spread: cookie.get("spread")
      })
        .then(res => {
          let data = res.data;
          let newTime = Math.round(new Date() / 1000);
          that.$store.commit(
            "LOGIN",
            data.token,
            dayjs(data.expires_time) - newTime
          );
          const backUrl = cookie.get(BACK_URL) || "/";
          cookie.remove(BACK_URL);
          that.$router.replace({ path: backUrl });
        })
        .catch(res => {
          that.$dialog.error(res.msg);
        });
    },
    async register() {
      var that = this;
      const { account, captcha, password } = that;
      try {
        await that
          .$validator({
            captcha: [
              required(required.message("verification code")),
              alpha_num(alpha_num.message("verification code"))
            ],
            password: [
              required(required.message("password")),
              attrs.range([6, 16], attrs.range.message("password")),
              alpha_num(alpha_num.message("password"))
            ]
          })
          .validate({ account, captcha, password });
      } catch (e) {
        return validatorDefaultCatch(e);
      }
      register({
        account: that.area + that.account,
        captcha: that.captcha,
        password: that.password,
        spread: cookie.get("spread")
      })
        .then(res => {
          that.$dialog.success(res.msg);
          that.formItem = 1;
        })
        .catch(res => {
          that.$dialog.error(res.msg);
        });
    },
    async code() {
      var that = this;
      const { account } = that;
      try {
        await that.$validator({}).validate({ account });
      } catch (e) {
        return validatorDefaultCatch(e);
      }
      if (that.formItem == 2) that.type = "register";
      await registerVerify({ phone: that.area + that.account, type: that.type })
        .then(res => {
          that.$dialog.success(res.msg);
          that.sendCode();
        })
        .catch(res => {
          that.$dialog.error(res.msg);
        });
    },
    navTap: function(index) {
      this.current = index;
    },
    chooseArea: function() {
      this.$router.push({ path: "/selectCode" });
    },
    async submit() {
      const { area, account, password } = this;
      try {
        await this.$validator({
          // account: [
          //   required(required.message("账号")),
          //   attrs.range([5, 16], attrs.range.message("账号")),
          //   alpha_num(alpha_num.message("账号"))
          // ],
          password: [
            required(required.message("password")),
            attrs.range([6, 16], attrs.range.message("password")),
            alpha_num(alpha_num.message("password"))
          ]
        }).validate({ account, password });
      } catch (e) {
        return validatorDefaultCatch(e);
      }
      this.$dialog.loading.open("loading");
      login({ account: area + account, password })
        .then(({ data }) => {
          this.$dialog.loading.close();

          this.$store.commit("LOGIN", data.token, dayjs(data.expires_time));
          const backUrl = cookie.get(BACK_URL) || "/";
          cookie.remove(BACK_URL);
          this.$router.replace({ path: backUrl });
        })
        .catch(e => {
          this.$dialog.loading.close();

          this.$dialog.error(e.msg);
        });
    }
  }
};
</script>
<style>
.fb-signin-button {
  /* This is where you control how the button looks. Be creative! */
  display: block;
  /*position: absolute;*/
  /*bottom: 0.5rem;*/
  /*left: 0;*/
  /*right: 0;*/
  z-index: 1000;
  /*padding: 4px 8px;*/
  border-radius: 3px;
  background-color: #4267b2;
  color: #fff;
  width: 50%;
  height: 1rem;
  margin: 0 auto;
  line-height: 1rem;
}
</style>
